import React from "react";
import { Link } from "react-router-dom";
import LegalDocumentTopBack from "./LegalDocumentTopBack";
import SiteFooter from "../components/SiteFooter";
import { useTranslation } from "../i18n/useTranslation";
import { useUiLocale } from "../context/UiLocaleContext";
import PrivacyEnglishBody from "../legal/PrivacyEnglishBody";
import PrivacyHebrewBody from "../legal/PrivacyHebrewBody";

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();
  const { uiLocale } = useUiLocale();
  const isHe = uiLocale === "he";

  return (
    <div className="relative min-h-screen flex flex-col bg-brandBeige">
      <main
        id="main-content"
        tabIndex={-1}
        className="relative z-10 mx-auto w-full max-w-2xl flex-1 px-4 py-10"
      >
        <LegalDocumentTopBack />
        <article lang={isHe ? "he" : "en"} dir={isHe ? "rtl" : "ltr"} className="text-start">
          <p className="text-sm text-body mb-2">{t("legal.lastUpdated")}</p>
          <h1 className="text-3xl font-extrabold text-heading mb-6">{t("legal.privacyTitle")}</h1>
          {isHe ? <PrivacyHebrewBody /> : <PrivacyEnglishBody />}
        </article>
        <p className="mt-8">
          <Link
            to="/"
            className="font-semibold text-brandNavy hover:underline focus:outline-none focus:ring-2 focus:ring-brandOrange rounded"
          >
            ← {t("orderSummary.backHome")}
          </Link>
          {" · "}
          <Link
            to="/terms"
            className="font-semibold text-brandNavy hover:underline focus:outline-none focus:ring-2 focus:ring-brandOrange rounded"
          >
            {t("legal.termsTitle")}
          </Link>
        </p>
      </main>
      <SiteFooter />
    </div>
  );
};

export default PrivacyPolicy;
